import { Card } from "@/components/ui/card";
import { FileText, ClipboardList, Award, ChevronRight, TrendingUp } from "lucide-react";
import { ageString } from "./shared";
import { mediaUrl } from "@/lib/media";

const MENU = [
  { key: "notes", icon: FileText, title: "Bugünkü Notlar", sub: "Öğretmen ders notları", bg: "bg-violet-100", fg: "text-violet-600" },
  { key: "tasks", icon: ClipboardList, title: "Bu Haftaki Görevler", sub: "Evde yapılacaklar", bg: "bg-amber-100", fg: "text-amber-600" },
  { key: "bep", icon: Award, title: "BEP Programı", sub: "Bireysel eğitim planı", bg: "bg-fuchsia-100", fg: "text-fuchsia-600" },
  { key: "chart", icon: TrendingUp, title: "Gelişim Grafiği", sub: "Aylık ilerleme", bg: "bg-emerald-100", fg: "text-emerald-600" },
];

export default function HomeView({ user, student, students, onSelectStudent, nav }) {
  return (
    <div data-testid="parent-home">
      <p className="text-sm text-slate-500">Merhaba</p>
      <h1 className="font-heading text-3xl font-bold tracking-tight text-slate-900">{user?.name}</h1>

      {students.length > 1 && (
        <div className="mt-4 flex gap-2 overflow-x-auto pb-1">
          {students.map((s) => (
            <button key={s.id} onClick={() => onSelectStudent(s.id)} data-testid={`home-child-chip-${s.id}`}
              className={`whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors ${student?.id === s.id ? "bg-violet-600 text-white" : "bg-white text-slate-600 border border-slate-200"}`}>
              {s.full_name}
            </button>
          ))}
        </div>
      )}

      {student && (
        <button onClick={() => nav.goTab("profile")} data-testid="home-child-card"
          className="mt-5 flex w-full items-center gap-4 rounded-3xl bg-gradient-to-br from-violet-600 via-indigo-500 to-blue-500 p-5 text-left shadow-[0_10px_30px_rgba(79,70,229,0.35)] transition-transform active:scale-[0.99]">
          <div>
            {student.photo_url ? (
              <img src={mediaUrl(student.photo_url)} alt="" className="h-16 w-16 rounded-full border-2 border-white/70 object-cover" />
            ) : (
              <div className="flex h-16 w-16 items-center justify-center rounded-full border-2 border-white/70 bg-white/25 text-xl font-bold text-white">{student.full_name.charAt(0)}</div>
            )}
          </div>
          <div className="min-w-0 flex-1">
            <h2 className="truncate font-heading text-xl font-bold text-white">{student.full_name}</h2>
            <p className="text-sm text-white/80">{ageString(student.birth_date)}</p>
          </div>
          <ChevronRight className="h-5 w-5 text-white/80" />
        </button>
      )}

      <div className="mt-4 space-y-3">
        {MENU.map((m) => (
          <button key={m.key} data-testid={`home-menu-${m.key}`}
            onClick={() => (m.key === "notes" || m.key === "chart" ? nav.goSub(m.key) : nav.goTab(m.key))}
            className="flex w-full items-center gap-4 rounded-2xl bg-white p-4 text-left shadow-[0_2px_10px_rgba(0,0,0,0.05)] transition-transform active:scale-[0.99]">
            <div className={`flex h-11 w-11 items-center justify-center rounded-xl ${m.bg}`}><m.icon className={`h-5 w-5 ${m.fg}`} /></div>
            <div className="flex-1">
              <p className="font-heading font-semibold text-slate-900">{m.title}</p>
              <p className="text-sm text-slate-400">{m.sub}</p>
            </div>
            <ChevronRight className="h-5 w-5 text-slate-300" />
          </button>
        ))}
      </div>
    </div>
  );
}
